import { render } from "./saveOrDiscardModal.vue?vue&type=template&id=f6936f4c"
import script from "./saveOrDiscardModal.vue?vue&type=script&lang=js"
export * from "./saveOrDiscardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__